import Clipboard from '~/ui/clipboard'
import { globalToast } from  '~/utils'

export const copyText = (text: string, toast = '已复制') => {
  if(!text) return
  Clipboard.setString(text)
  globalToast.show(toast)
}
